import { create } from 'zustand';

export type Ids =
  | 'at'
  | 'bentoville1'
  | 'bentoville2'
  | 'carrot'
  | 'dark'
  | 'mmhmm'
  | 'partners'
  | 'sora'
  | 'soraGradient'
  | 'white';
export type LogoColor = 'none' | Ids;

interface Marks {
  [key: string]: Record<string, number>;
}

interface Defaults {
  toggle: boolean;
  value: string;
}

interface SiteState {
  activeSection: Ids;
  addMarks: (payload: { key: string; id: string; value: number }) => void;
  backgroundColor: Ids | null;
  defaults: Defaults;
  inView: Ids | null;
  logoColor: LogoColor;
  marks: Marks;
  progressBySection: Record<Ids, number>;
  setBackgroundColor: (backgroundColor: Ids) => void;
  setLogoColor: (logoColor: LogoColor) => void;
  setProgressBySection: (sectionId: Ids, progress: number) => void;
  updateDefaults: (newDefaults: Partial<Defaults>) => void;
  updateInView: (activeSection: Ids) => void;
  updateSection: (activeSection: Ids) => void;
}

// Create the Zustand store
export const useStore = create<SiteState>((set, get) => ({
  activeSection: 'at',
  inView: null,
  logoColor: 'white',
  backgroundColor: null,
  defaults: {
    value: '250ms',
    toggle: false,
  },
  progressBySection: {
    at: 0,
    bentoville1: 0,
    bentoville2: 0,
    carrot: 0,
    dark: 0,
    mmhmm: 0,
    sora: 0,
    soraGradient: 0,
    white: 0,
    partners: 0,
  },

  setProgressBySection(sectionId, progress) {
    const p = get().progressBySection;
    set({ progressBySection: { ...p, [sectionId]: progress } });
  },

  updateDefaults: (newDefaults) => {
    set((state) => ({
      defaults: { ...state.defaults, ...newDefaults },
    }));
  },

  // set which section is fully in viewport
  updateInView: (inView) => set({ inView }),
  // set which section is partially in the viewport
  updateSection: (activeSection) => set({ activeSection }),

  // change colors
  setLogoColor: (logoColor: LogoColor) => set({ logoColor }),
  setBackgroundColor: (backgroundColor) => set({ backgroundColor }),

  // marks is a multiuse object that will store all measurements, progress and coordinates
  marks: {},

  // add or update marks
  addMarks: ({ key, id, value }) => {
    const currentMarks = get().marks;

    // Ensure the 'key' exists in the marks object
    const updatedKeyMarks = { ...currentMarks[key], [id]: value };

    // Create the updated marks object
    const updatedMarks = {
      ...currentMarks,
      [key]: updatedKeyMarks,
    };
    // Set the updated marks in the store
    set({ marks: updatedMarks });
  },
}));
